// TokenManager.js
// Handles token refresh and queues requests during refresh
import axios from 'axios';
class TokenManager {
    constructor() {
        this.token = null;
        this.refreshing = false;
        this.lastFailedRefresh = null;
        this.defaultTimeout = 10000; // Default timeout for token requests
        if (typeof window !== 'undefined') {
            window.addEventListener('online', () => {
                if (this.lastFailedRefresh) {
                    this.refreshToken();
                }
            });
        }
    }
    setToken(token) {
        this.token = token;
    }
    getToken() {
        return this.token;
    }
    async refreshToken(timeout = this.defaultTimeout) {
        if (typeof window !== 'undefined' && !navigator.onLine) {
            // Wait for online event before retrying
            await new Promise(resolve => {
                const handler = () => {
                    window.removeEventListener('online', handler);
                    resolve();
                };
                window.addEventListener('online', handler);
            });
        }
        if (this.refreshing) {
            // Wait for the current refresh to finish
            return new Promise((resolve, reject) => {
                const check = () => {
                    if (!this.refreshing) {
                        if (this.token) resolve(this.token);
                        else reject(new Error('Token refresh failed'));
                    } else {
                        setTimeout(check, 100);
                    }
                };
                check();
            });
        }
        this.refreshing = true;
        try {
            // Replace with actual token refresh API call
            const newToken = await this._fetchNewToken(timeout);
            this.token = newToken;
            this.refreshing = false;
            this.lastFailedRefresh = null;
            return newToken;
        } catch (e) {
            console.error("Token fetch request failed:", e);
            this.refreshing = false;
            this.lastFailedRefresh = Date.now();
            throw e;
        }
    }
    async _fetchNewToken(timeout = this.defaultTimeout) {
        // need to write code to fetch the updated token
    }
}

export default new TokenManager();
